var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto my-10 d-flex justify-center",staticStyle:{"text-align":"center"}},[_c('v-img',{attrs:{"src":_vm.TitleName,"alt":_vm.AltText,"width":"100%","max-width":"640"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }